import React from 'react';

export default function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}
